/**
 *  @module geo/functionalities
 */

import {Observable} from 'rxjs/Observable';
import {FilterValue} from '../types/functionality';
import {Functionality} from '.';
export interface StatisticExecutionParameters {
  /**
   * list of filters to apply
   */
  filters?: FilterValue[];
  /**
   * text to display in filters panel
   */
  filtersLabel: string;

  hierarchyValues: any;

  iconId: any;
}
export class StatisticFunctionality extends Functionality {
  getService() {
    throw new Error('Method not implemented.');
  }

  public static typeDef = 'com.bg.functionality.stat.Statistic';

  /**
   * Open statistic
   *
   *
   * @since v2.0.2
   * @param parameters
   * @returns {Observable<any>}
   */
  public execute(parameters: StatisticExecutionParameters): Observable<any> {
    return super.execute(parameters);
  }
}